"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _UserEngageCard = require("./UserEngageCard");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _caroselWrapper, _wrapper;
  return {
    headline: {
      marginBottom: "".concat(theme.spacing(10), "px !important"),
      marginTop: "".concat(theme.spacing(10), "px !important")
    },
    caroselWrapper: (_caroselWrapper = {
      margin: '20px auto',
      padding: theme.spacing(6),
      borderRadius: '5px',
      background: theme.palette.common.white
    }, (0, _defineProperty2.default)(_caroselWrapper, theme.breakpoints.down('xs'), {
      border: '0 none',
      boxShadow: 'none',
      padding: 0
    }), (0, _defineProperty2.default)(_caroselWrapper, '& .slider-frame .slide-current', {
      '@media (max-width: 450px)': {
        marginLeft: '-3.5%'
      },
      '@media (min-width: 451px) and (max-width: 600px)': {
        marginLeft: '-5.5%'
      }
    }), _caroselWrapper),
    caroselWrapperShadow: (0, _defineProperty2.default)({
      border: "1px solid ".concat(theme.palette.grey[300]),
      boxShadow: "1px 2px 3px 0px ".concat(theme.palette.grey[500])
    }, theme.breakpoints.down('xs'), {
      border: '0 none',
      boxShadow: 'none',
      padding: 0
    }),
    wrapper: (_wrapper = {}, (0, _defineProperty2.default)(_wrapper, theme.breakpoints.down('xs'), {
      padding: "".concat(theme.spacing(0), " !important")
    }), (0, _defineProperty2.default)(_wrapper, '@media (max-width: 1350px)', {
      padding: theme.spacing(0, 5)
    }), _wrapper),
    itemWrapper: {
      fontSize: theme.typography.pxToRem(14),
      wordBreak: 'break-word',
      textAlign: 'center'
    },
    leftNavButton: (0, _defineProperty2.default)({
      left: '-15px'
    }, theme.breakpoints.down('xs'), {
      display: 'none'
    }),
    rightNavButton: (0, _defineProperty2.default)({
      right: '-15px'
    }, theme.breakpoints.down('xs'), {
      display: 'none'
    }),
    navArrow: {
      fontSize: theme.typography.pxToRem(28),
      color: theme.palette.secondary.main
    },
    navArrowDisabled: {
      color: theme.palette.text.disabled
    }
  };
});
var UserEngageCarousel = function UserEngageCarousel(_ref) {
  var title = _ref.title,
    items = _ref.items,
    cardsPerRotation = _ref.cardsPerRotation,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    delay = _ref.delay,
    autopauseDisabled = _ref.autopauseDisabled,
    anchorId = _ref.anchorId,
    shadow = _ref.shadow;
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var mediaQueryMdUp = (0, _useMediaQuery.default)(theme.breakpoints.up('md'));
  var SlideToShowNumber = 3.5;
  if (mediaQueryMdUp) {
    SlideToShowNumber = cardsPerRotation;
  }
  return __jsx("div", {
    id: anchorId,
    className: "aem-ms-cmp aem-ms-userEngage-carousel ".concat(classes.wrapper)
  }, title && __jsx("h2", {
    className: classes.headline,
    dangerouslySetInnerHTML: {
      __html: title.slice(0, 90)
    }
  }), __jsx("div", {
    className: (0, _clsx.default)(classes.caroselWrapper, shadow && classes.caroselWrapperShadow)
  }, __jsx(_nukaCarousel.default, {
    autoplay: autoplay,
    autoplayInterval: delay,
    pauseOnHover: !autopauseDisabled,
    slidesToShow: SlideToShowNumber,
    slidesToScroll: SlideToShowNumber,
    cellSpacing: mediaQueryMdUp ? 32 : 8,
    wrapAround: items && (items === null || items === void 0 ? void 0 : items.length) >= cardsPerRotation,
    dragging: !mediaQueryMdUp,
    renderCenterLeftControls: function renderCenterLeftControls(props) {
      var disabled = props.currentSlide === 0;
      return items && items.length > cardsPerRotation ? __jsx(_core.ButtonBase, {
        className: classes.leftNavButton,
        disabled: disabled,
        onClick: function onClick() {
          return props.previousSlide();
        },
        "aria-label": "previous"
      }, __jsx(_KeyboardArrowLeft.default, {
        className: (0, _clsx.default)(classes.navArrow, disabled && classes.navArrowDisabled)
      })) : null;
    },
    renderBottomCenterControls: null,
    renderCenterRightControls: function renderCenterRightControls(props) {
      return items && items.length > cardsPerRotation ? __jsx(_core.ButtonBase, {
        className: classes.rightNavButton,
        onClick: function onClick() {
          return props.nextSlide();
        },
        "aria-label": "next"
      }, __jsx(_KeyboardArrowRight.default, {
        className: (0, _clsx.default)(classes.navArrow, props.slidesToScroll)
      })) : null;
    }
  }, items && items.length > 0 && Array.isArray(items) ? items.map(function (item, index) {
    return __jsx("div", {
      key: index,
      className: classes.itemWrapper
    }, __jsx(_UserEngageCard.UserEngageCard, item));
  }) : null)));
};
var UserEngageCarouselEditConfig = {
  emptyLabel: 'User Engage Carousel',
  isEmpty: function isEmpty(props) {
    if (props.title || typeof props.items !== 'undefined' && props.items.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/userEngageCarousel')(UserEngageCarousel, UserEngageCarouselEditConfig);
exports.default = _default;